import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Checkbox/Checkbox.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/design/components/checkbox/react'} mdxType="DeprecationBanner" />
    <h2>{`Examples`}</h2>
    <Note variant="warning" mdxType="Note">
      <p><strong parentName="p">{`Use `}<a parentName="strong" {...{
            "href": "/FormControl"
          }}>{`FormControl`}</a>{` to display an accessible checkbox form field`}</strong>{`. This `}<inlineCode parentName="p">{`Checkbox`}</inlineCode>{` component is intended only as an ingredient for other custom components, or as a drop-in replacement for native HTML checkboxes outside of form use-cases.`}</p>
      <p>{`If you do use this component to build a custom checkbox, it should always be accompanied by a corresponding `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` to improve support for assistive technologies.`}</p>
    </Note>
    <p>{`The `}<inlineCode parentName="p">{`Checkbox`}</inlineCode>{` component can be used in controlled and uncontrolled modes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<form>
  <FormControl>
    <Checkbox id="default-checkbox" />
    <FormControl.Label>Default checkbox</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox id="always-checked-checkbox" checked />
    <FormControl.Label>Always checked</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox id="always-unchecked-checkbox" />
    <FormControl.Label>Always unchecked</FormControl.Label>
  </FormControl>
  <FormControl disabled>
    <Checkbox id="inactive-checkbox" checked />
    <FormControl.Label>Inactive</FormControl.Label>
  </FormControl>
</form>
`}</code></pre>
    <Note variant="warning" mdxType="Note">
  Checkbox components should always be accompanied by a corresponding label to improve support for assistive
  technologies.
    </Note>
    <h3>{`Indeterminate`}</h3>
    <p>{`An `}<inlineCode parentName="p">{`indeterminate`}</inlineCode>{` checkbox state should be used if the input value is neither true nor false. This can be useful in situations where you are required to display an incomplete state, or one that is dependent on other input selections to determine a value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<form>
  <FormControl>
    <Checkbox onChange={() => {}} indeterminate={true} />
    <FormControl.Label>Default checkbox</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox checked={true} onChange={() => {}} />
    <FormControl.Label>Checkbox 1</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox checked={false} onChange={() => {}} />
    <FormControl.Label>Checkbox 2</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox checked={false} onChange={() => {}} />
    <FormControl.Label>Checkbox 3</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox checked={false} onChange={() => {}} />
    <FormControl.Label>Checkbox 4</FormControl.Label>
  </FormControl>
</form>
`}</code></pre>
    <h3>{`Grouping Checkbox components`}</h3>
    <p>{`If you're not building something custom, you should use the `}<a parentName="p" {...{
        "href": "/CheckboxGroup"
      }}>{`CheckboxGroup`}</a>{` component to render a group of checkbox inputs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<form>
  <CheckboxGroup>
    <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
    <FormControl>
      <Checkbox value="1" />
      <FormControl.Label>Checkbox 1</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="2" />
      <FormControl.Label>Checkbox 2</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="3" />
      <FormControl.Label>Checkbox 3</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="4" />
      <FormControl.Label>Checkbox 4</FormControl.Label>
    </FormControl>
  </CheckboxGroup>
</form>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/CheckboxInputField"
        }}>{`CheckboxInputField`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      